import { useState, useEffect, useCallback } from 'react';

const THEME_KEY = 'theme-preference';

// We only support dark mode now. Any existing "light" preference
// is ignored and we always normalize to "dark".
function getSavedTheme() {
  const saved = localStorage.getItem(THEME_KEY);
  if (saved === 'dark') return 'dark';
  return null;
}

export default function useTheme() {
  const [theme, setTheme] = useState(() => {
    const saved = getSavedTheme();
    if (saved) return saved;
    // Default to dark when there is no saved preference
    // or when a legacy "light" value is present.
    return 'dark';
  });

  // Apply theme to document
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  // Ensure any future calls (if added) keep us in dark mode.
  const toggleTheme = useCallback(() => {
    setTheme('dark');
    localStorage.setItem(THEME_KEY, 'dark');
  }, []);

  return { theme, toggleTheme };
}
